"use client";
import { montserrat } from "@/lib/font";
import { useAppSelector } from "@/lib/hooks";
import { setDownload } from "@lib/features/reportSlice";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { useTranslations } from "next-intl";
import { useDispatch } from "react-redux";

const PopupDownloadSuccess = () => {
  const t = useTranslations("messages");
  const { isDownload } = useAppSelector((state) => state.report);
  const dispatch = useDispatch();
  const handleCloseDownload = () => {
    dispatch(setDownload(false));
  };

  return (
    <Dialog
      maxWidth="sm"
      open={isDownload}
      onClose={handleCloseDownload}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle className="flex justify-between items-center">
        <Box className="flex items-center">
          <p
            className="text-ciBlue_900 font-semibold text-2xl/6 m-0"
            translation-key="popup_download_title"
          >
            {t("popup_download_title")}
          </p>
        </Box>
        <Box>
          <IconButton
            className="!bg-eerie_black_5 size-8 !p-1"
            onClick={handleCloseDownload}
          >
            <CloseIcon className="text-[rgba(28, 28, 28, 0.4)]" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className={`gap-8 grid px-8 pt-6 pb-8 ${montserrat}`}>
        <p
          className="font-normal text-base/6 text-gray_90 m-0"
          translation-key="popup_download_success_message"
        >
          {t("popup_download_success_message")}
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default PopupDownloadSuccess;
